var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngineTrouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.665 30.931c-5.992 0-14.068-.026-19.911-.055M7.214 30.836H4.328v-4.06a2.056 2.056 0 0 1 .905-1.702 21.303 21.303 0 0 1 6.134-2.816c4.587-.107 24.817 0 24.817 0l2.158-2.375 2.97 1.566 5.016.87v6.475s-1.566 1.836-3.616 2.05c-.119 0-.348.024-.676.035",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.275 19.775c-14.404-5.663-23.24 2.442-23.24 2.442",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.065 33.77a3.799 3.799 0 1 0 0-7.597 3.799 3.799 0 0 0 0 7.598zM42.036 30.871a3.802 3.802 0 1 1-7.388-1.794 3.802 3.802 0 0 1 7.388 1.794z",
    stroke: "currentColor",
    strokeMiterlimit: "0.2em"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.44 17.87v13.056",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m5.053 17 8.312 5.229",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.71 23.606h-2.97v1.456h2.97v-1.456zM46.328 23.606H43.47v1.456h2.86v-1.456z",
    stroke: "currentColor",
    strokeMiterlimit: "0.2em"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.065 32.271a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6zM38.342 32.271a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6z",
    stroke: "currentColor",
    strokeMiterlimit: "0.2em",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineTrouble);
export default __webpack_public_path__ + "static/media/engine-trouble.d6de44b46a1a47a04ba4397656765fd0.svg";
export { ForwardRef as ReactComponent };